var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cp-loader"},[(_vm.loaderText)?_c('div',{staticClass:"cp-loader-text"},[_vm._v(_vm._s(_vm.loaderText))]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cp-loader-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }